import React, { useState } from "react";
import { Table, Button } from "react-bootstrap";
import _ from "lodash";
// import { t } from "i18next";
import Utils from "../../../../utils/index";

const SavedContextComponent = ({
  instanceList,
  currentInstanceId,
  instanceData,
  stateValue,
  // formik,
  // getEmptyValues,
  // initialValues,
  // setFilelist,
  // setInstanceName,
  // setCurrentInstanceId,
  // setInitialValues,
  // assistantData,
  // instanceName,
  // setInstanceObj,
  // setActiveTab,
  // setNoConext
  simulation,
}) => {
  const [contextColumns, setContextColumns] = useState([
    simulation ? { title: "Simulation Name" } : { title: "Context Name" },
    { title: "Status" },
    { title: "Created On" },
    { title: "Action" },
  ]);
  const currentUser = JSON.parse(Utils.getLocalStorageItem("currentUser"));
  return (
    <>
      {instanceList.length > 0 && (
        <div className="overflow-auto table-theme file-upload-table">
          <Table className="table-striped" size="md">
            <thead>
              <tr>
                {contextColumns.map((c) => {
                  return (
                    <th key={c.title}>
                      <div className="d-flex role-th gap-1">{c?.title}</div>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {_.map(instanceList, (instance, index) => {
                const filteredInstance = _.omit(instance, ["instanceUuid"]);
                const matchingInstances = instanceData.filter(
                  (data) => data?.userId !== currentUser?.emailID
                );

                return (
                  <tr key={index}>
                    {Object.entries(filteredInstance).map(([key, value]) => {
                      return (
                        <td
                          key={key}
                          className={
                            instance.instanceUuid === currentInstanceId
                              ? "highligted-row"
                              : ""
                          }
                        >
                          {value}
                          {matchingInstances.map((matchingInstance) => {
                            if (
                              matchingInstance.instanceUuid ===
                              instance.instanceUuid
                            ) {
                              return (
                                <div
                                  key={matchingInstance.userId}
                                  className="sharedId mt-1"
                                >
                                  {key === "name" &&
                                    `${
                                      stateValue === "openWithOwner"
                                        ? "Created By"
                                        : "Shared By"
                                    }: ${
                                      matchingInstance?.username
                                        ? matchingInstance?.username
                                        : matchingInstance?.userId
                                    }`}
                                </div>
                              );
                            }
                            return null;
                          })}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      )}
    </>
  );
};

export default SavedContextComponent;
